import React from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import HeadingMD from 'common/ui_components/headings/headingMD';
import { withTranslation } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  titleHolder: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4.5),
    },
  },
  title: {
    marginRight: theme.spacing(2),
  },
  titleSecond: {
    display: 'flex',
    alignItems: 'center',
  },
  starIcon: {
    color: theme.palette.warning.main,
    marginLeft: theme.spacing(0.5),
  },
  dot: {
    fontSize: theme.typography.pxToRem(40),
    color: theme.palette.secondary.dark,
    margin: theme.spacing(0, 1),
    lineHeight: theme.typography.pxToRem(15),
    alignSelf: 'self-start',

    [theme.breakpoints.up('lg')]: {
      lineHeight: theme.typography.pxToRem(20),
    },
  },
  reviewsCount: {
    color: theme.palette.secondary.light,
    whiteSpace: 'nowrap',
  },
}));

const ReviewsTitle = (props) => {
  const {
    t, title, rateAvg, reviewsCount,
  } = props;
  const classes = useStyles();

  return (
    <>
      <div className={classes.titleHolder}>
        <div className={classes.title}>
          <HeadingMD title={title} />
        </div>

        <div className={classes.titleSecond}>
          {rateAvg && (
          <>
            <HeadingMD title={rateAvg} />
            <StarIcon className={classes.starIcon} />
            <span className={classes.dot}> </span>
          </>
          )}

          <span className={classes.reviewsCount}>

            {reviewsCount > 0 ? (
              <>
                {reviewsCount}
                {' '}
                {t('fe_es_reviews_title:reviews')}
              </>
            ) : (
              t('fe_es_reviews_title:no_reviews')
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default withTranslation('fe_es_reviews_title')(ReviewsTitle);
